<template>
    <div class="bg-growth rounded-full text-white p-2 fixed top-5 px-6 ml-60" v-if="saved">{{ $t('saved') }}</div>
    
    <section class="bg-white dark:bg-dark.tableBG dark:text-dark.textOnBkg ml-24 p-3 mt-4 rounded mr-3 relative border border-sepBorder dark:border-dark.sepBorder">
        <div class="float-right">
            <MazSelect v-if="filteredModelsList.length > 0" size="sm" v-model="selectedModel" class="float-left" :options="filteredModelsList" label="Model" search v-slot="{ option }" option-input-value-key="label" >
                <div class="flex items-center" style="width: 100%; gap: 1rem">
                    <MazAvatar size="0.6rem" :src="option.picture" class="cover" cover />
                    <strong>{{ option.label }}</strong>
                </div>
            </MazSelect>

            <span v-else class="text-panelsText dark:text-dark.panelsText float-left mr-5 text-base mt-2">{{ $t('no_models') }}</span>
            <div class="hidden">
                <font-awesome-icon icon="fas fa-question-circle" class="text-lg text-panelsText dark:text-dark.panelsText cursor-pointer" @mouseenter="displayLegend = true"  @mouseleave="displayLegend = false" />
                <div v-bind:class="{'hidden':displayLegend == false}" class="bg-button text-buttonText absolute mt-5 p-2 rounded border border-black" v-html="$t('models_search_notice')"></div>
            </div>

            <MazPicker
                v-model="dRange"
                size="sm"
                pickerPosition="right"
                :label="$t('select_period')"
                :max-date="new Date().toISOString().split('T')[0]"
                double
                class="ml-3"
            />

            <div class="float-right mx-2 relative">
                <button @click="showColumnDropdown = !showColumnDropdown" class="bg-mazUIBg text-mazUiText dark:bg-dark.mazUIBg dark:text-dark.mazUiText rounded-xl cursor-pointer p-2.5 px-3 border border-sepBorder dark:border-dark.mazUIBg text-center whitespace-nowrap text-xs">
                    {{ $t('show_hide') }} <font-awesome-icon :icon="['fas', 'angle-down']" />
                </button>
                <div v-if="showColumnDropdown" class="absolute z-10 bg-mazUIBg text-mazUiText dark:bg-dark.mazUIBg dark:text-dark.mazUiText rounded-lg shadow-lg p-2 mt-1 right-0">
                    <div class="flex items-center mb-1 border-b border-sepBorder dark:border-dark.sepBorder pb-1">
                        <input type="checkbox" id="showAll" :checked="allColumnsVisible" @change="toggleAllColumns" class="mr-2" />
                        <label for="showAll" class="cursor-pointer">{{ $t('show_all') }}</label>
                    </div>
                    <div v-for="column in togglableColumns" :key="column.name" class="flex items-center" >
                        <input type="checkbox" :id="column.name" v-model="columnVisibility[column.name]" class="mr-2"/>
                        <label :for="column.name" class="cursor-pointer">{{ column.label }}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="clear-both"></div>

        <section class="grid grid-cols-3 w-full mt-5 mb-5 px-3">
            <div class="row-span-2 p-4 px-7 border-r border-sepBorder dark:border-dark.sepBorder capitalize font-bold items-center">
                <div  v-if="selectedModelIndex >= 0" class="flex items-center">
                    <div class="rounded-full h-12 w-12 shadow bg-gray-200 dark:bg-gray-700" :style="{ backgroundImage: modelsList[selectedModelIndex]?.avatar ? `url(${modelsList[selectedModelIndex]?.avatar})` : null, backgroundSize: 'cover', backgroundPosition: 'center'}"></div>
                    <div class="ml-3">
                        <div class="truncate">{{ modelsList[selectedModelIndex]?.free?.name }}</div>
                        <img :src="$platformLogo(modelsList[selectedModelIndex])" :title="modelsList[selectedModelIndex]?.platformName" :alt="modelsList[selectedModelIndex]?.platformName" class="h-4"/>
                    </div>
                </div>

                <div class="mt-6">
                    <span class="font-bold text-2xl text-growth">${{ parseFloat(netEarnings).toFixed(2) }}</span><br />
                    <span class="text-sm">{{ $t('net_earnings') }}</span>
                </div>
            </div>
            <slot v-for="(s,i) in summary" :key="i">
                <div v-if="!(modelsList[selectedModelIndex]?.platform == 2 && i == 3)" class="p-4 px-7 border-r border-sepBorder dark:border-dark.sepBorder flex justify-between items-center">
                    <div class="leading-4">
                        <span class="font-bold text-xl">$ {{ s.value.toFixed(2) }}</span><br />
                        <span class="text-xs">{{ s.name }}</span>
                    </div>
                    <div class="rounded-full bg-growth bg-opacity-20 text-growth w-9 h-9 text-center p-1.5"><font-awesome-icon :icon="s.icon" /></div>
                </div>
            </slot>
        </section>

        <div v-show="1==2" class="grid grid-cols-2 gap-5 w-full">
            <div class="mx-auto inline mr-5 w-full">
                <h3 class="font-bold text-lg mb-5 ml-2">{{ $t('earnings') }}</h3>
                <!--<apexchart
                    type="line"
                    :options="chartOptions"
                    :series="series"
                    class="w-full"
                    >
                </apexchart>
            </div>
            <div class="mx-auto inline mr-5 w-full">
                <h3 class="font-bold text-lg mb-5 ml-2">{{ $t('detailed_earnings') }}</h3>
                <apexchart
                    type="line"
                    :options="chartOptions"
                    :series="series"
                    class="w-full"
                    >
                </apexchart>-->
            </div>
        </div>

        <slot v-if="displayTab == 1">
            <section>
                <div class="text-white float-left w-full sm:mr-5 mb-10 block max-h-200 mt-3 overflow-y-auto relative">
                    <table class="text-tableText bg-tableBG dark:bg-dark.tableBG dark:text-dark.tableText w-full text-sm sm:text-base" id="transactionsTable">
                        <thead class="sticky top-0">
                            <tr class="bg-tableBG dark:bg-dark.tableBG">
                                <th class="border border-sepBorder dark:border-dark.sepBorder cursor-pointer py-2" >
                                    {{ $t('date') }}
                                </th>
                                <th v-if="columnVisibility.time" class="border border-sepBorder dark:border-dark.sepBorder cursor-pointer">
                                    {{ $t('time') }}
                                </th>
                                <th v-if="columnVisibility.net" class="border border-sepBorder dark:border-dark.sepBorder relative">
                                    {{ $t('net') }}
                                </th>
                                <th v-if="columnVisibility.username" class="border border-sepBorder dark:border-dark.sepBorder">
                                    {{ $t('username') }}
                                </th>
                                <th v-if="columnVisibility.type" class="border border-sepBorder dark:border-dark.sepBorder px-2" >
                                    {{ $t('type') }}
                                </th>
                                <th class="border border-sepBorder dark:border-dark.sepBorder px-2">
                                    {{ $t('actions') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="transactionsObj && transactionsObj.free && transactionsObj.free.length > 0">
                            <tr v-for="(transaction, index) in transactionsObj.free" :key="index" :class="{ 'bg-tableRow1 dark:bg-dark.tableRow1': index % 2 == 0 }" >
                                <td class="text-center p-1 px-1 border border-sepBorder dark:border-dark.sepBorder">
                                    {{ formatDate(transaction.createdDate + ' ' + transaction.createdTime) }}
                                </td>
                                <td v-if="columnVisibility.time" class="text-center p-1 px-1 border border-sepBorder dark:border-dark.sepBorder">
                                    {{ formatTime(transaction.createdDate + ' ' + transaction.createdTime) }}
                                </td>
                                <td v-if="columnVisibility.net" class="text-center p-1 px-1 border border-sepBorder dark:border-dark.sepBorder" >
                                    $ {{ transaction.net }}
                                </td>
                                <td v-if="columnVisibility.username" class="text-center p-1 px-1 border border-sepBorder dark:border-dark.sepBorder" >
                                    {{ transaction.follower_user_name }}
                                </td>
                                <td v-if="columnVisibility.type" class="text-center p-1 border border-sepBorder dark:border-dark.sepBorder" >
                                    <span class="hidden sm:contents">{{ transaction.TransType }}</span>
                                    <transaction-type class="sm:hidden" :t="transaction.TransType" />
                                </td>
                                <td class="text-center p-1 border border-sepBorder dark:border-dark.sepBorder" @click="changeCharge('free', index)" >
                                    <font-awesome-icon icon="fas fa-rotate-left" :class="{
                                        'text-gray-500 dark:text-gray-200': openIndex == 'free' + index || openIndex != 'free' + index,
                                        'text-red-300': transaction.reverse && transaction.reverseTimeStamp }" class="px-3 cursor-pointer" />
                                </td>
                                <div v-if="!(transaction.reverse && transaction.reverseTimeStamp) && openIndex == 'free' + index" class="absolute bg-gray-100 z-50 rounded p-2 -ml-36 mt-9 text-black cursor-pointer border border-sepBorder dark:border-dark.sepBorder" :class="{ 'hidden': !transaction.reverse }" >
                                    <dInput vmodel="changeNet" vvalue="''" @changeNet="changeNet = $event" />
                                    <button @click="saveTimeStamp('free', index, transaction.transactionID, transaction.modelID), openIndex = null" class="bg-green-400 text-black rounded-full mt-1 p-1 px-4 text-base float-right" >
                                        {{ $t('save') }}
                                    </button>
                                </div>
                                <div v-else-if="transaction.reverse && transaction.reverseTimeStamp && openIndex == 'free' + index" @click="removeTimeStamp('free', index, transaction.transactionID, transaction.modelID), openIndex = null" class="absolute bg-gray-100 z-50 rounded p-2 pr-4 -ml-16 mt-9 text-black cursor-pointer border border-sepBorder dark:border-dark.sepBorder">
                                    <font-awesome-icon icon="fas fa-xmark" class="mr-2 ml-2" />
                                    {{ $t('remove') }}
                                </div>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="clear-both"></div>
            </section>
        </slot>

        <!-- REVERSE -->
        <slot v-else>
            <table v-if="reverseObj && reverseObj.metrics" class="w-min bg-tableBG text-contentText mt-5">
                <thead>
                    <tr class="border border-sepBorder dark:border-dark.sepBorder">
                        <th></th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder" colspan="2">FREE</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder" colspan="2">PAID</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder" colspan="2">{{ $t('together') }}</th>
                    </tr>
                    <tr>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-1 px-3">{{ $t('date') }}</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-1 px-3">{{ $t('amount') }}</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-1 px-3">{{ $t('price') }}</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-1 px-3">{{ $t('amount') }}</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-1 px-3">{{ $t('price') }}</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-1 px-3">{{ $t('amount') }}</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-1 px-3">{{ $t('price') }}</th>
                    </tr>
                </thead>
                <slot v-for="(stats,index) in reverseObj.metrics" :key="index">
                    <tr class="whitespace-nowrap" :class="{'bg-tableRow1':index%2==0}">
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{stats.date}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{stats.freeAmount.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">$ {{stats.freePrice.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{stats.paidAmount.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">$ {{stats.paidPrice.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{stats.togetherAmount.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">$ {{stats.togetherPrice.toFixed(2)}}</td>
                    </tr>
                </slot>
                <tfoot v-if="reverseObj.metricsSummary">
                    <tr class="text-center whitespace-nowrap bg-panels">
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{ $t('summary') }}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{reverseObj.metricsSummary.amountF.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">$ {{reverseObj.metricsSummary.priceF.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{reverseObj.metricsSummary.amountP.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">$ {{reverseObj.metricsSummary.priceP.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{reverseObj.metricsSummary.amountT.toFixed(2)}}</td>
                        <td class="p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">$ {{reverseObj.metricsSummary.priceT.toFixed(2)}}</td>
                    </tr>
                </tfoot>
            </table>
            <div v-else class="my-5">
                {{ $t('no_reverse') }}
            </div>
            <section class="ml-28 container flex gap-10" v-if="reverseObj">
                <div class="text-white bold mb-10" v-for="(reverse,ind) in reverseObj.values" :key="ind" v-bind:class="{'mt-5':reverse, 'mt-5': !reverse}">
                    <h1 class="uppercase ml-2 mb-2 text-2xl font-semibold">{{ind}}</h1>
                    <table class="text-tableText bg-tableBG w-max" id="transactionsTable" v-if="reverse">
                        <thead>
                            <tr>
                                <th onclick="sortTable(0,'transactionsTable')" class="cursor-pointer" @click="sortColumn=0" >{{ $t('date') }} &nbsp; <font-awesome-icon icon="fas fa-sort" v-bind:class="{'text-button':sortColumn == 0}" /></th>
                                <th onclick="sortTable(1,'transactionsTable')" class="cursor-pointer" @click="sortColumn=1" >{{ $t('time') }} &nbsp; <font-awesome-icon icon="fas fa-sort" v-bind:class="{'text-button':sortColumn == 0}" /></th>
                                <th onclick="sortTable(3,'transactionsTable')" class="cursor-pointer" @click="sortColumn=3" >{{ $t('net') }} &nbsp; <font-awesome-icon icon="fas fa-sort" v-bind:class="{'text-button':sortColumn == 2}" /></th>
                                <th>{{ $t('username') }}</th>
                                <th>{{ $t('type') }}</th>
                                <th>{{ $t('reversed_at') }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="h-max overflow-y-scroll">
                            <tr v-for="(transaction, index) in reverse" :key="index">
                                <td class="text-center p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{ formatDate(transaction.createdDate + " " + transaction.createdTime) }}</td>
                                <td class="text-center p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{ formatTime(transaction.createdDate + " " + transaction.createdTime) }}</td>
                                <td class="text-center p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">$ {{ transaction.net }}</td>
                                <td class="text-center p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{ transaction.follower_user_name}}</td>
                                <td class="text-center p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{ transaction.TransType}}</td>
                                <td class="text-center p-1 px-3 border border-sepBorder dark:border-dark.sepBorder">{{ transaction.reverseTimeStamp}}</td>
                                <td class="cursor-pointer p-1 px-3 text-center border border-sepBorder dark:border-dark.sepBorder" @click="changeCharge(ind,index)"><font-awesome-icon icon="fas fa-rotate-left" v-bind:class="{'text-gray-500':openIndex==ind+index,'text-gray-500':openIndex!=ind+index,'text-red-300':transaction.reverse && transaction.reverseTimeStamp}" class="px-3 cursor-pointer" /></td>
                                <div v-if="!(transaction.reverse && transaction.reverseTimeStamp) && openIndex==ind+index" 
                                    class="absolute bg-gray-100 z-50 rounded p-2 -ml-36 mt-9 text-black cursor-pointer" v-bind:class="{'hidden' :!transaction.reverse}">
                                    <dInput vmodel="changeNet" vvalue='' @changeNet="changeNet = $event" />
                                    <button @click="saveTimeStamp(ind,index,transaction.transactionID,transaction.modelID),openIndex=null" class="bg-green-400 text-black rounded-full mt-1 p-1 px-4 text-base float-right">{{ $t('save') }}</button>
                                </div>
                                <div v-else-if="transaction.reverse && transaction.reverseTimeStamp && openIndex==ind+index"
                                    @click="removeTimeStamp(ind,index,transaction.transactionID,transaction.modelID), openIndex=null"
                                    class="absolute bg-gray-100 z-50 rounded p-2 pr-4 -ml-16 mt-9 text-black cursor-pointer">
                                    <font-awesome-icon icon="fas fa-xmark" class="mr-2 ml-2" /> {{ $t('remove') }} 
                                </div>
                            </tr>
                            <tr v-if="reverse.length>0" class="text-white">
                                <td class="text-center text-gray-300 py-2 border border-sepBorder dark:border-dark.sepBorder">{{ $t('summary') }}:</td>
                                <td v-if="ind == 'free'" class="text-center border border-sepBorder dark:border-dark.sepBorder" colspan="3"><span class="text-gray-300">{{ $t('net') }}:</span> $ {{reverseObj.netF.toFixed(2)}}</td>
                                <td v-else class="text-center border border-sepBorder dark:border-dark.sepBorder" colspan="3"><span class="text-gray-300">{{ $t('net') }}:</span> $ {{reverseObj.netP.toFixed(2)}}</td>
                                <td class="text-center border border-sepBorder dark:border-dark.sepBorder" colspan="3">
                                    <span class="text-gray-300">{{ $t('count') }}: </span>
                                    <span v-if="ind == 'free'">{{reverseObj.noF}}</span>
                                    <span v-else>{{reverseObj.noP}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else class="text-white">
                        {{ $t('select_creator') }}
                    </div>
                </div>
            </section>
        </slot>
    </section>

</template>

<script setup>
    import filterSelect from "@/components/transactions/filterSelect.vue"
    import dInput from "@/components/inputTransactions.vue"
    import transactionType from "@/components/transactionType.vue"
</script>

<script>
import { useAuthStore } from '@/stores/auth';
import { get_models, getTransactionsStats } from '@/api/api.js';
export default {
    props:{
        changeNet: {default() {return null;}},
        srchUser: {default() {return '';}},
        srchType: {default() {return null;}},
        srchNetFrom: {default() {return 0;}},
        srchNetTo: {default() {return 0;}}
    },
    data() {
        return { 
            modelsList: [],
            loading: true,
            saved: false,
            displayFilter:null,
            mounted:false,
            sortColumn: null,
            transactionsObj: {free: [], paid:[]},
            reverseObj: null,
            transactionsStats: null,
            openIndex: null,
            timeZone: null,
            displayTab:1,
            searchBy:0,
            selectedPlatform: null,
            selectedEmpl: null,
            selectedModel: null,
            selectedModelIndex: 0,
            fetchingData: false,
            displayLegend: false,
            dRange: {
                start: this.$moment().subtract(10, 'days').format("YYYY-MM-DD"),
                end: this.$moment().format("YYYY-MM-DD"),
            },
            netEarnings: 0,
            summary: [
                {name: this.$t('messages'), value: 0, icon: ["fas", "fa-message"]},
                {name: this.$t('tips'), value: 0, icon: ["fas", "fa-hand-holding-dollar"]},
                {name: this.$t('subscriptions'), value: 0, icon: ["fas", "fa-repeat"]},
                {name: this.$t('posts'), value: 0, icon: ["fas", "fa-file-pen"]},
                /*{name: this.$t('refferals'), value: 0, icon: ["fas", "share-nodes"]},
                {name: this.$t('streams'), value: 0, icon: ["fas", "tower-broadcast"]},*/
            ],
            chartOptions: {
                chart: {
                    id: 'line-chart',
                    background: 'transparent', 
                },
                theme: {
                    mode: localStorage.getItem('darkMode') === 'true' ? 'dark' : 'light', // Automatically adapts to dark mode
                },
                xaxis: {
                    categories: [],
                },
                stroke: {
                    curve: 'smooth',
                },
                animations: {
                    enabled: true,
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 350
                    }
                }
            },
            series: [
                {
                    name: 'Earnings',
                    data: [],
                },
            ],
            showColumnDropdown: false, // Controls dropdown visibility
            columnVisibility: {
                time: true,     // Time column visible by default
                net: true,      // Net column visible by default
                username: true, // Username column visible by default
                type: true,     // Type column visible by default
            },
        } 
    },
    computed: {
        authStore() {
            return useAuthStore();
        },
        myself() {
            return this.authStore.myself;
        },
        permissions() {
            return this.authStore.permissions;
        },
        allColumnsVisible() {
            return Object.values(this.columnVisibility).every((visible) => visible);
        },
        filteredModelsList() {
            if (!this.modelsList) return [];
            let r = this.modelsList.map(({ avatar, free }) => ({
                picture: avatar,
                label: free.name,
                value: free.id
            }));
            return r;
        },
        togglableColumns() {
            return [
                { name: 'time', label: this.$t('time') },
                { name: 'net', label: this.$t('net') },
                { name: 'username', label: this.$t('username') },
                { name: 'type', label: this.$t('type') },
            ];
        },
    },
    watch: {
        srchType: function() { this.searchBy = 1; },
        srchUser: function() { this.searchBy = 0; },
        srchNetFrom: function() { this.searchBy = 2; },
        srchNetTo: function() { this.searchBy = 2; },
        selectedModel: function() {
            this.selectedModelIndex = this.modelsList.findIndex(({ free }) => free.id === this.selectedModel);
            if (this.displayTab === 1) {
                this.getData(true);
            } else {
                this.getReverse();
            }
        },
        dRange: function() {
            this.dateFrom = this.dRange.start;
            this.dateTo = this.dRange.end;
            //dateFrom and dateTo are in format YYYY-MM-DD and I need to create a dateArray that will be a array of datas in format YYYY-MM-DD between dateFrom and dateTo
            var dateArray = [];
            var currentDate = this.$moment(this.dateFrom);
            var stopDate = this.$moment(this.dateTo);
            while (currentDate <= stopDate) {
                dateArray.push(this.$moment(currentDate).format('YYYY-MM-DD'));
                currentDate = this.$moment(currentDate).add(1, 'days');
            }

            this.chartOptions = {
                ...this.chartOptions,
                xaxis: {
                    categories: dateArray,
                },
            };
            this.series = [
                {
                    name: 'Earnings',
                    data: dateArray.map(() => Math.floor(Math.random() * 100)),
                },
            ];

            if (this.mounted && this.selectedModel) {
                if (this.displayTab == 1) {
                    this.getData(true);
                } else {
                    this.getReverse();
                }
            }
        },
    },
    components() { dInput, filterSelect, transactionType},
    methods: {
        toggleAllColumns(event) {
            const isChecked = event.target.checked;
            for (const column in this.columnVisibility) {
                this.columnVisibility[column] = isChecked;
            }
        },
        dFilter(filter) {
            this.displayFilter = filter
            this.srchUser = ''
        },
        dTab(w) {
            this.displayTab = w
            if (w == 2) {
                this.getReverse();
            } else {
                this.getData(true);
            }
        },
        changeCharge(type,index) {
            if (this.permissions && this.$getPermission(this.permissions,15) && this.$getPermission(this.permissions,26).is_granted) {
                if (this.displayTab == 1) {
                    this.transactionsObj[type][index].reverse = 1;
                    this.openIndex = type+index
                } else {
                    this.reverseObj.values[type][index].reverse = 1;
                    this.openIndex = type+index
                }
            }
        },
        removeTimeStamp(type,index,transactionID,modelID) {
            if (this.permissions && this.$getPermission(this.permissions,15) && this.$getPermission(this.permissions,26).is_granted) {
                if (confirm('Are you sure?')) {
                    //odošli cez Axios.
                    this.$axios.post("transactions/postTransactions.php", {
                        action: "removereverse",
                        modelID: modelID,
                        transactionID: transactionID,
                        companyID: this.$cookies.get('c_id'),
                        userToken: this.$cookies.get('userToken')
                    }).then((result) => {
                        if (this.displayTab == 1) {
                            this.transactionsObj[type][index].reverse = null;
                            this.transactionsObj[type][index].reverseTimeStamp = null;
                        } else {
                            this.reverseObj.values[type].splice(index,1);
                        }
                    }, (error) => {
                    });
                }
            }
        },
        saveTimeStamp(type,index,transactionID,modelID) {
            if (this.permissions && this.$getPermission(this.permissions,15) && this.$getPermission(this.permissions,26).is_granted) {
                if (this.changeNet) {
                    //odošli cez Axios.
                    this.$axios.post("transactions/postTransactions.php", {
                        action: "savereverse",
                        modelID: modelID,
                        timeStamp: this.changeNet,
                        transactionID: transactionID,
                        companyID: this.$cookies.get('c_id'),
                        userToken: this.$cookies.get('userToken')
                    }).then((result) => {
                        this.transactionsObj[type][index].reverse = 1;
                        this.transactionsObj[type][index].reverseTimeStamp = this.$moment(this.changeNet).format('YYYY.MM.DD HH:mm');
                    }, (error) => {
                    });
                }
            }
        },
        determinZoneDST(original) {
            var tzone = 0;
            if (this.$moment().isDST()) {
                if (this.$moment(original,"YYYY-MM-DD HH:mm:ss").isDST()) {
                    tzone = parseInt(this.timeZone)
                } else {
                    tzone = (parseInt(this.timeZone)/60-1)*60
                }
            } else {
                if (this.$moment(original,"YYYY-MM-DD HH:mm:ss").isDST()) {
                    tzone = (parseInt(this.timeZone)/60+1)*60
                } else {
                    tzone = parseInt(this.timeZone)
                }
            }
            return tzone;
        },
        formatTime(original) {
            var tzone = this.determinZoneDST(original);
            if (tzone<0) {
                return this.$moment(original,"YYYY-MM-DD HH:mm:ss").format("HH:mm:ss");
            } else {
                return this.$moment(original,"YYYY-MM-DD HH:mm:ss").format("HH:mm:ss");
            }
        },
        formatDate(original) {
            var tzone = this.determinZoneDST(original);
            if (parseInt(this.timeZone)<0) {
                return this.$moment(original,"YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
            } else {
                return this.$moment(original,"YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
            }
        },        
        getWholeGraph() {
            this.$axios.get("transactions/", {
                params: {
                    userToken: this.$cookies.get('userToken'),
                    build: "statistics",
                    selectedModel: this.selectedModel,
                    fromDate: null,
                    toDate: null,
                    companyID: this.$cookies.get('c_id')
                }
            }).then((result) => {
                this.transactionsStats = result.data
            }, (error) => {
            });
        },
        getData(stats) {
            if (this.fetchingData) return;
            if (this.selectedModel == null) return;

            this.fetchingData = true;
            //load transactions of this model
            this.updateSummary();
            this.$axios.get("transactions/", {
                params: {
                    userToken: this.$cookies.get('userToken'),
                    build: "getModelsTransactions",
                    model_id: this.selectedModel,
                    fromDate: this.dateFrom ? this.$moment(this.dateFrom).format("YYYY-MM-DD") : this.$moment().subtract(10, 'days').format("YYYY-MM-DD"),
                    toDate: this.dateTo ? this.$moment(this.dateTo).format("YYYY-MM-DD") : new Date().toISOString().split('T')[0],
                    companyID: this.$cookies.get('c_id')
                }
            }).then((result) => {
                this.transactionsObj = result.data
            }, (error) => {
            }).finally(() => this.loading = false, setTimeout(() => this.fetchingData = false, 500));
        },
        getReverse(target) {
            let cancelLoading = false;
            if (this.loading != true) {
                cancelLoading = true;
                this.loading = true;
            }
            let sModel = null;
            if (target != 'group') {
                sModel = this.selectedModel;
            }
            //load transactions of this model
            this.$axios.get("transactions/", {
                params: {
                    userToken: this.$cookies.get('userToken'),
                    build: "getReverses",
                    selectedGroup: this.selectedGroup,
                    selectedModel: sModel,
                    fromDate: this.dateFrom ? this.$moment(this.dateFrom).format("YYYY-MM-DD") : this.$moment().subtract(10, 'days').format("YYYY-MM-DD"),
                    toDate: this.dateTo ? this.$moment(this.dateTo).format("YYYY-MM-DD") : new Date().toISOString().split('T')[0],
                    companyID: this.$cookies.get('c_id')
                }
            }).then((result) => {
                this.reverseObj = result.data;
            }, (error) => {
            }).finally(() => cancelLoading ? this.loading = false : null);
        },
        async updateSummary() {
            const modelTransactionsSum = await getTransactionsStats(
                this.$cookies.get('userToken'),
                this.$cookies.get('c_id'),
                this.selectedModel, 
                this.dRange.start, 
                this.dRange.end
            );
            this.summary.forEach((s, i) => {
                s.value = modelTransactionsSum?.types[i] ?? 0;
            });
            this.netEarnings = modelTransactionsSum?.net ?? 0;
        }
    },
    async mounted() {
        this.modelsList = await get_models(this.$cookies.get('userToken'),this.$cookies.get('c_id'),1,null,null);
        if (this.modelsList && this.modelsList.length > 0) {this.selectedModel = this.modelsList[0]?.free?.id ?? null;}
        this.getData(true);
        this.mounted = true;
    }
}

</script>

<style scoped>
  td {
    padding:5px;
    text-align:center;
  }
</style>